import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { IIdItemInfo } from '../models/resourceInfoParts';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RemoteRefreshSchedules } from '../resources/RemoteRefreshSchedules';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentActionNotification } from './ContentActionNotification';

export class DeleteRemoteRefreshSchedulesAction {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
    'ContentActionNotification',
    'RemoteRefreshSchedules'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private ContentActionNotification: ContentActionNotification,
    private RemoteRefreshSchedules: RemoteRefreshSchedules) { }

  public execute(context: IActionContext,
      item: IIdItemInfo,
      selected: Set<IRemoteRefreshScheduleInfo>): ng.IPromise<IResult> {

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: this.$translate.instant('confirmDeleteRemoteRefreshSchedules', { COUNT: selected.size() }, L10n.Interpolations.Count),
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: selected.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.RemoteRefreshSchedules.del(item.id, selected)
          .then((result: IResult) => {
            if (result.errors && result.errors.length) {
              const errorMessage = this.errorMessageFor(result.errors[0]);
              dialogInstance.showErrorMessage(errorMessage);
            } else {
              this.ContentActionNotification.notifySuccess(
                this.$translate.instant('deleteRemoteRefreshScheduleSuccess', { ITEM_COUNT: selected.size() }, L10n.Interpolations.Count));
            }
            return result;
          });
      }
    }).result;
  }

  private errorMessageFor(error: IError) {
    return this.$translate.instant('errorUnknown');
  }

}

Module.instance().service('DeleteRemoteRefreshSchedulesAction', DeleteRemoteRefreshSchedulesAction);
